import { render, staticRenderFns } from "./BannerBox.vue?vue&type=template&id=88e0bf7e&"
import script from "./BannerBox.vue?vue&type=script&lang=js&"
export * from "./BannerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports